import React from 'react'
import { StudyTabs, TabPane} from '@/components/StudyTabs'
import BankList from './BankList'
import ElectricList from './ElectricList'
import DigitalList from './DigitalList'
import {useParams} from "react-router-dom";

const Scheme: React.FC = () => {
  const { id } = useParams()

  return (
    <main className='wrap-scheme header-top'>
      <StudyTabs activeKey={id || '1'}>
        <TabPane title="银行业" key="1">
          <BankList></BankList>
        </TabPane>
        <TabPane title="电力行业" key="2">
          <ElectricList></ElectricList>
        </TabPane>
        <TabPane title="数字化建设" key="3">
          <DigitalList></DigitalList>
        </TabPane>
      </StudyTabs>
    </main>
  )
}

export default Scheme